import React from "react";
import styled from "styled-components";

export default styled.div`
    background: white;
    position: absolute;
    left: 418px;   
    height: 100vh;
    overflow-y: scroll;
    text-align: left; 
    padding: 10px 32px;
    box-sizing: border-box;
    display: none;
    z-index: 4;
    box-shadow: 5px 5px 25px #00000054;
    padding-left: 121px;
    padding-right: 121px;
    padding-top: 97px;
    padding-bottom: 128px;
    width: calc(100% - 418px);
    
    .modal-button {
        margin-top: 20px;
    }
    
    hr {
        clear: both;
        width: 100%;
        border-top: 1px solid #E4E4E4 !important;
    }
    
    .heading-note {
        margin-top: -16px;
        color: #6A6D90;
        font-size: 20px;
    }
    
    strong {
        font-weight: 700;
    }
    .refresh-button {
        width: 129px;
        height: 53px;
        display: inline-block;
        text-align: center;
        box-shadow: 0 0 15px #0000002b;
        padding-top: 14px;
        font-family: 'Effra';
        font-size: 20px;
        font-weight: 500;
        float: right;
        top: 117px;
        position: absolute;
        right: 120px;
        cursor: pointer;
    }
    
    .hidden {
        display: none;
    }
    
    hr {
        border: none !important;
        box-shadow: none !important;
        border-top: 1px solid #E4E4E4 !important;
        margin-top: 40px;
        margin-bottom: 30px;
    }
    
    .rte {
        min-height: 300px;
        width: 93%;
        margin: 0 auto;
    }
    
    table {
        width: 100%;
        overflow-y: scroll;
        border: 1px solid #979797;
        border-collapse: collapse;
    }
    
    .status-accepted {
        background: #24A159;
        font-size: 13px;
        color: white;
        text-align: center;
        width: 112px;
        height: 28px;
        display: block;
        margin: 0 auto;
        padding-top: 4px;
        border-radius: 60px;
        font-weight: 700;
        letter-spacing: 1px;
    }
    
    .status-pending {
        background: #909090;
        font-size: 13px;
        color: white;
        text-align: center;
        width: 112px;
        height: 28px;
        display: block;
        margin: 0 auto;
        padding-top: 4px;
        border-radius: 60px;
        font-weight: 700;
        letter-spacing: 1px;
    }
    
    p {
        color: #6A6D90;
        font-size: 20px;
        line-height: 24px;
    }
    
    h3 {
        font-weight: 700;
        font-size: 20px;
        color: #888888;
    }
    
    table a {
        color: #6A6D90;
    }
    
    table tr {
    }
    
    table td {
        padding: 15px 30px;
        color: #6A6D90;
        height: 60px;
        font-size: 20px;
        border: 1px solid #979797;
        
    }
    table td:nth-child(4) a {
        text-decoration: none;
    }
    
    table th:nth-child(3),
    table th:nth-child(4),
    table td:nth-child(3),
    table td:nth-child(4) {
        text-align: center;
    }
    
    table th {
        padding: 11px 30px;
        color: #5562C0;
        font-size: 17px;
        font-weight: 700;
        height: 48px;
        border: 1px solid #979797;
        background: #F9FAFF;
    }
    
    ${(props) => (props.open ? {
    'display': 'block',
} : '')}
    
    ${(props) => (props.is_tablet ? {
    'width': 'calc(100% - 80px) !important',
    'left': '80px !important',
} : '')}
`;